__turbopack_context__.v({
  "bg": "arena-section-module__psiHUG__bg",
  "buttonWrapper": "arena-section-module__psiHUG__buttonWrapper",
  "defaultText": "arena-section-module__psiHUG__defaultText",
  "gif": "arena-section-module__psiHUG__gif",
  "gifWrapper": "arena-section-module__psiHUG__gifWrapper",
  "grayText": "arena-section-module__psiHUG__grayText",
  "highlightedWord": "arena-section-module__psiHUG__highlightedWord",
  "mpGif": "arena-section-module__psiHUG__mpGif",
  "mpGifWpapper": "arena-section-module__psiHUG__mpGifWpapper",
  "parWrapper": "arena-section-module__psiHUG__parWrapper",
  "root": "arena-section-module__psiHUG__root",
  "sectionContent": "arena-section-module__psiHUG__sectionContent",
  "textBlockTitle": "arena-section-module__psiHUG__textBlockTitle",
  "textWrapper": "arena-section-module__psiHUG__textWrapper",
  "title": "arena-section-module__psiHUG__title",
  "unitedSectionsTitle": "arena-section-module__psiHUG__unitedSectionsTitle",
});
